const styles = (theme) => ({
  kpiContainer: {
    height: "100%",
    marginLeft: 16,
    marginRight: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    overflow: "auto",
    whiteSpace: "nowrap",
  },
  rowContainer: {
    display: "flex",
    height: "100%",
    "&:not(:last-of-type)": {
      borderBottom: `1px solid ${theme.AppBGColor}`,
    },
  },
  lastRowContainer: {
    display: "flex",
    height: "100%",
    paddingLeft: 33,
  },
  expand: {
    transform: "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
    padding: 2,
    opacity: 0.8,
    alignSelf: "center",
    border: `1px solid ${theme.iconColor}`,
  },
  expandOpen: {
    transform: "rotate(0deg)",
    padding: 2,
    alignSelf: "center",
  },
  expandIcon: {
    color: theme.iconColor,
    height: 18,
    width: 18,
  },
  layout: {
    backgroundColor: theme.ModalBGColor,
    flexGrow: 1,
    theme: theme.themeName,
  },
});

export default styles;